import { Box, useMediaQuery } from '@mui/material';
import { Button } from '../button/button';
import { NormalText } from '../styles';
import { useState } from 'react';
import { formatLargeText, truncateWithEllipsis } from '../utils';

export const KeyText = ({ label, value }) => {
  const [showValue, setShowValue] = useState(false);

  const isMobile = useMediaQuery('(max-width: 800px)');
  const labelLength = isMobile ? 24 : 48;

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={'8px'}
      justifyContent={'space-between'}
      width={'100%'}
    >
      <NormalText size={14} color={'#0F110C'}>
        {label}
      </NormalText>
      <Box
        display={'flex'}
        gap={'8px'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <NormalText
          size={14}
          color={'#0F110C'}
          isBold
          letterSpacing={!showValue && '1.5px'}
        >
          {showValue
            ? value
            : truncateWithEllipsis(
                '*'.repeat(value?.length || 0),
                labelLength,
                ''
              )}
        </NormalText>
        <Box display={'flex'} gap={'8px'}>
          <Button
            startIcon={'CopySimple'}
            type={'regular'}
            iconSize={16}
            onClick={() => {
              navigator.clipboard.writeText(value);
            }}
            buttonStyles={{
              svg: {
                transition: '.2s',
                fill: '#8E8E93',
                '&:hover': {
                  fill: '#1976D2',
                },
              },
            }}
          />
          <Button
            startIcon={showValue ? 'EyeSlash' : 'Eye'}
            type={'regular'}
            iconSize={16}
            onClick={() => {
              setShowValue((prev) => !prev);
            }}
            buttonStyles={{
              svg: {
                transition: '.2s',
                fill: '#8E8E93',
                '&:hover': {
                  fill: '#1976D2',
                },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
